// Modules
import React, { Component } from 'react';

// Styles
import './Calendar.scss'

// Components
import Week from '../Week';
import { weekdays } from 'moment';
import { waitForElement } from '@testing-library/react';

interface IProps {
    month:number;
    year:number;
    enabledDates: (string | Date)[];
    activeDate: Date | null;
    rangeStartDate?: string;
    rangeEndDate?: string;
}

const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

class Calendar extends Component<IProps> {
    constructor(props: IProps) {
        super(props);
        this.getDaysInMonth = this.getDaysInMonth.bind(this);
    }

    getDaysInMonth():Date[] {
        var date = new Date(this.props.year, this.props.month, 1);
        var days = [];
        while (date.getMonth() === this.props.month) {
          days.push(new Date(date));
          date.setDate(date.getDate() + 1);
        }
        return days;
    }

    getWeeks():Date[][] {
        let days = this.getDaysInMonth();
        let weeks:Date[][] = [];
        let weekDays:Date[] = [];
        let activeDates: Date [] = [];
        let enabledWeeks:Date[][] = [];
        let finalMonthlyWeeks: Date[][] = [];

        this.props.enabledDates.map((d:any) => {
            activeDates.push(d.dates)
        })

        days.forEach((day:Date, index:number) => {
            weekDays.push(day);
    
            if (day.getDay() == 6 || index == days.length -1) {   
                 weeks.push(weekDays)                   
                 weekDays = [];
            }

        })
        
        weeks.map((week:Date[]) => {
            activeDates.map((date:Date) => {
              if(week.some(dates => dates.valueOf() === date.valueOf())) {
                enabledWeeks.push(week)
              }
            })
            
        })
        
        let temp:any = new Set(enabledWeeks)
        finalMonthlyWeeks = [...temp]
       
        return finalMonthlyWeeks;
    }



    getDateStamp(date:Date) {
        return (`${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`)
    }

    render() {
        return (
            <div className="calendar">

                <table>
                    <tbody>
                    <tr>
                        {dayNames.map((day:string) =>
                            <th key={day}><div className="day-heading">{day}</div></th>
                        )}
                    </tr>
                    {this.getWeeks().map((week:Date[]) =>
                        <Week
                            rangeStartDate={this.props.rangeStartDate}
                            rangeEndDate ={this.props.rangeEndDate} 
                            key={"week-" + this.getDateStamp(week[0])}
                            weekDays={week}
                            enabledDates={this.props.enabledDates}
                            activeDate={this.props.activeDate}
                            className="week"
                        />
                    )}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default Calendar;
